// export const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';
export const GOOGLE_SHEETS_REDIRECT = process.env.REACT_APP_GOOGLE_SHEETS_REDIRECT || 'http://localhost:3000/sh';

// export const API_HOST = process.env.REACT_APP_API_HOST || 'https://devapi.escapespy.com';
export const API_HOST = 'https://liveapi.escapespy.com';

export const SITE_DOMAIN = process.env.REACT_APP_SITE_DOMAIN || 'https://www.escapespy.com';
export const INTUIT_CLIENT_ID = process.env.REACT_APP_INTUIT_CLIENT_ID || 'Q0k7JuD2EEgB9acE7IfOo4k6vukN1BKvM3bvnqEFshT49pfZ85';
export const INTUIT_REDIRECT_URI = process.env.REACT_APP_INTUIT_REDIRECT_URI || 'http://localhost:3000/oauth/intuit';
export const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID || 'ca_GLNIBQKn4svmsl4yREQmS2PRqeXOFNle';
export const STRIPE_REDIRECT_URI = process.env.REACT_APP_STRIPE_REDIRECT_URI || 'http://localhost:3000/pro/settings';
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || 'pk_test_XcUQueXwwOWS7Yqm9Aei9dPt00pWR6C1xt';



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/